
import { useEffect, useState } from "react";
import ModalWrapper from 'components/ModalWrapper'
import DataTrainingService from 'api/services/DataTrainingService'
import { useTranslation } from "react-i18next";
import { FaTag } from 'react-icons/fa'
import { getLanguageKey } from "utils/Utils";
import PropTypes from 'prop-types';

const AssignIntent = ({ disabled, message, onDataSubmit }) => {

    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [intents, setIntents] = useState();
    const [selectedIntent, setSelectedIntent] = useState();
    const [newIntent, setNewIntent] = useState();
    const [newIntentError, setNewIntentError] = useState(false);

    const onChange = (value) => {
        setSelectedIntent(value)
    }


    const onApply = () => {
        if (selectedIntent && selectedIntent === 'new_intent') {
            if (newIntent) {
                setNewIntentError(false);
                onDataSubmit(message._id, {
                    intent: newIntent,
                    status: "understood",
                    is_new_intent: true
                }
                )
                setIsOpen(false);
            } else {
                setNewIntentError(true);
            }
        } else {
            onDataSubmit(message._id, {
                intent: selectedIntent,
                status: "understood",
                is_new_intent: false
            }
            )
            setIsOpen(false);
        }
    }

    useEffect(() => {
    }, [isOpen])

    useEffect(() => {
        DataTrainingService.getIntentList(getLanguageKey(message?.language)).then((resp) => {
            if (resp) {
                setIntents(resp);
                setSelectedIntent(Object.keys(resp)[0])
            }

        }).catch((err) => {
            //Handle error ..
        });
        return false
    }, [message?.language]);


    return (
        <>
            <button disabled={!!disabled}
                className={`flex justify-center font-medium items-center capitalize  focus:outline-none focus:ring-2 focus:ring-offset-2  transition duration-150 ease-in-out 
              rounded  py-1 pl-2 pr-4 text-sm
               ${disabled ? 'bg-gray-200 text-gray-400' : 'text-blue-600 bg-blue-50   focus:ring-blue-600 hover:bg-blue-100'}`}
                onClick={() => setIsOpen(true)}>
                <FaTag className=" mr-2" />  {t('actions.assign_intent')}

            </button>

            <ModalWrapper
                open={isOpen}
                setOpen={setIsOpen}
                title={t('actions.assign_intent')}
            >

                {
                    message && intents &&

                    <div className="w-[480px]">
                        {/* Message */}
                        {message?.message &&
                            <>
                                <div className="text-gray-800 font-medium leading-tight tracking-normal pb-2 ">
                                    {t('data_training.message_not_understood')}:
                                </div>
                                <div className="px-4 py-2 border w-fit bg-gray-50 rounded-t-xl rounded-br-xl">
                                    {message?.message}
                                </div>
                                <div className="text-gray-800 font-medium leading-tight tracking-normal pb-2 mt-2 ">
                                    {t('form.language')}:
                                </div>
                                <div className="px-4 py-2  w-fitrounded-t-xl rounded-br-xl">
                                    {message?.language}
                                </div>
                            </>
                        }


                        {/* Select Intent */}
                        <div className="  text-gray-800 py-2 mt-4">
                            <div className="text-gray-800 font-medium leading-tight tracking-normal pb-2">
                                {t('data_training.intents')}
                            </div>
                            <select
                                id='intent_select'
                                className="text-gray-600 dark:text-gray-400 focus:outline-none focus:border  focus:border-blue-700 dark:focus:border-blue-700 dark:border-gray-700 dark:bg-gray-800 bg-white font-normal flex items-center w-2/3 h-10 text-xs border-gray-300 rounded border shadow"
                                onChange={(e) => {
                                    onChange(e.target.value || undefined);
                                }}
                                disabled={disabled}
                            >
                                <option value="" disabled>Select Intent</option>
                                {Object.entries(intents).map((intent, i) => (
                                    <option key={intent[0]} value={intent[0]}>
                                        {intent[1]}
                                    </option>
                                ))}
                                <option key={'new_intent'} value={'new_intent'}>
                                    + {t('actions.new_intent')}
                                </option>
                            </select>

                        </div>

                        {/* If New Intent */}
                        {
                            selectedIntent === 'new_intent' &&
                            <NewIntent error={newIntentError} onChange={setNewIntent} />
                        }

                        {/* Actions */}
                        <div className="flex items-center justify-end w-full mt-8">

                            <button className=" capitalize focus:outline-none focus:ring-2 focus:ring-offset-2  focus:ring-gray-400  bg-gray-100 transition duration-150 text-gray-600 ease-in-out hover:border-gray-400 hover:bg-gray-300 border rounded px-8 py-2 text-sm"
                                onClick={() => setIsOpen(false)}
                            >{t('actions.cancel')}</button>

                            <button className="capitalize focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-700 transition duration-150 ease-in-out hover:bg-blue-600 bg-blue-500 rounded text-white px-8 py-2 text-sm ml-3"
                                type="submit"
                                onClick={onApply}
                            >{t('actions.apply')}</button>

                        </div>
                    </div>
                }
            </ModalWrapper>
        </>

    );

}


AssignIntent.propTypes = {
  disabled: PropTypes.bool,
  message: PropTypes.object.isRequired,
  onDataSubmit: PropTypes.func.isRequired,
};

export default AssignIntent;


const NewIntent = ({ onChange, error }) => {

    const { t } = useTranslation();

    return (
        <div className="my-1">
                <label htmlFor="new_intent" className="text-gray-800 text-sm font-medium leading-tight tracking-normal">{t('form.new_intent')}</label>
                <textarea
                    id="new_intent" rows="5" cols="40"
                    className="text-gray-600 focus:outline-none focus:border focus:border-blue-700 font-normal w-full h-16 flex items-center text-sm border-gray-300 rounded border"
                    placeholder={t('form.hint_new_intent')}
                    // {...register("notification_text", { required: true, maxLength: 1500 })}
                    onChange={(e) => {
                        onChange(e.target.value || undefined);
                    }}
                />
                {!!error && <p className="text-red-500 text-xs">{t('form.error_new_intent')}</p>}
            </div>
    );
}

NewIntent.propTypes = {
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
};
